<template>
<div class="row q-col-gutter-sm map-selector q-mt-md"
     :class=" {error: hasError}">
  <div class="col-12">
    <common-input
        v-model="searchQuery"
        @update:modelValue="searchMaps(searchQuery)"
        :loading="loadingMaps"
        label="Zoek kaartgroepen en kaarten"
        :error="hasError"
        :errorMessage="$errorMessage(name)"
        clearable />
  </div>
  <div class="col-4">
    <SearchResultTree
        :maps="allMaps"
        v-model="selection"
        :visibleMap="visibleMapId"
        :visibleMapGroup="visibleMapGroupId"
        @update:model-value="toggleVisibleSelection"
        @update:visible-map="toggleVisibleMap"
        @update:visible-map-group="toggleVisibleMapGroup"
    />
  </div>
  <div class="col-4">
    <SelectionTree
        :maps="selectedMaps"
        v-model="selection"
        :visibleMap="visibleMapId"
        :visibleMapGroup="visibleMapGroupId"
        @update:model-value="toggleVisibleSelection"
        @update:visible-map="toggleVisibleMap"
        @update:visible-map-group="toggleVisibleMapGroup"
    />
  </div>
  <div class="col-4">
    <BaseMap :geometry="visibleGeometry"
              auto-fit
              auto-fit-always
              height="278px"
              :is-loading="loadingMaps || loadingGeometry">
      <template v-slot:fullscreen-sidebar>
        <SearchResultTree
            :maps="allMaps"
            v-model="selection"
            :visibleMap="visibleMapId"
            :visibleMapGroup="visibleMapGroupId"
            @update:model-value="toggleVisibleSelection"
            @update:visible-map="toggleVisibleMap"
            @update:visible-map-group="toggleVisibleMapGroup"
        />
      </template>
    </BaseMap>
  </div>
  <template v-for="id in selection">
    <input type="hidden" :name="`${name}[]`" :value="id">
  </template>
</div>
</template>

<script>
import BaseMap from './BaseMap'
import SearchResultTree from './MapSelection/SearchResultTree.vue'
import SelectionTree from './MapSelection/SelectionTree'

export default {
  components: { SelectionTree, BaseMap, SearchResultTree },
  props: {
    mapIds: {
      type: Array,
      default: () => [],
    },
    name: {
      default: 'maps',
    },
  },
  data: () => ({
    loadingMaps: false,
    loadingGeometry: false,
    searchQuery: '',
    allMaps: [],
    selection: [],
    visibleMapId: null,
    visibleMapGroupId: null,
    visibleGeometry: null,
  }),
  watch: {
    mapIds (ids) {
      this.selection = ids
    },
  },
  methods: {
    searchMaps: _.debounce(async function (searchQuery) {
      if (searchQuery !== this.searchQuery) {
        return
      }
      this.loadingMaps = true
      const { data } = await axios.get(this.$route('api.mapgroup.search'), {
        params: {
          query: this.searchQuery,
        },
      })
      this.allMaps = data.map(mapGroup => ({
        id: mapGroup.id,
        title: mapGroup.title,
        maps: mapGroup.maps.map(map => ({
          title: map.title,
          id: map.id,
        })),
      }))
      this.loadingMaps = false
    }, 500),
    toggleVisibleSelection () {
      this.visibleMapId = null
      this.visibleMapGroupId = null
      this.updateVisibleGeometry()
    },
    toggleVisibleMap (mapId) {
      this.visibleMapId = mapId
      this.visibleMapGroupId = null
      this.updateVisibleGeometry()
    },
    toggleVisibleMapGroup (mapGroupId) {
      this.visibleMapId = null
      this.visibleMapGroupId = mapGroupId
      this.updateVisibleGeometry()
    },
    updateVisibleGeometry () {
      if (this.visibleMapId) {
        return this.loadMapGeometry(this.visibleMapId)
      }
      if (this.visibleMapGroupId) {
        return this.loadMapGroupGeometry(this.visibleMapGroupId)
      }
      return this.loadSelectionGeometry()
    },
    async loadMapGeometry (mapId) {
      this.loadingGeometry = true
      try {
        const { data } = await axios.get(this.$route('api.map.show', { map: mapId }))
        this.visibleGeometry = data
      } catch (e) {
        console.error(e)
      } finally {
        this.loadingGeometry = false
      }
    },
    async loadMapGroupGeometry (mapGroupId) {
      this.loadingGeometry = true
      try {
        const { data } = await axios.get(this.$route('api.mapGroup.show', { mapGroupId: mapGroupId }))
        this.visibleGeometry = data
      } catch (e) {
        console.error(e)
      } finally {
        this.loadingGeometry = false
      }
    },
    loadSelectionGeometry: _.debounce(async function () {
      if (this.selection.length === 0) {
        this.visibleGeometry = ''
        return
      }
      this.loadingGeometry = true
      const map_ids = [...this.selection]
      const { data } = await axios.post(this.$route('api.map.combine'), { map_ids })
      if (map_ids.length === this.selection.length) {
        this.visibleGeometry = data
      }
      this.loadingGeometry = false
    }, 500),
  },
  computed: {
    selectedMaps () {
      return this.allMaps.reduce((selected, mapGroup) => {
        const maps = mapGroup.maps.filter(map => this.selection.includes(map.id))
        if (maps.length) {
          selected.push({
            title: mapGroup.title,
            id: mapGroup.id,
            maps,
          })
        }
        return selected
      }, [])
      this.selectedMaps = this.selection.reduce((maps, group) => {
        return maps.concat(group.maps.map(map => map.id))
      }, [])
      return this.selectedMaps
    },
    hasError () {
      return this.$hasError(this.name)
    },
  },
  mounted () {
    this.selection = this.mapIds
    this.searchMaps(this.searchQuery)
    this.loadSelectionGeometry()
  },
}
</script>
